var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-message"},[_c('h2',[_vm._v("Hello ChatGPT !")]),_vm._v(" "),_c('h1',[_vm._v(" TODO: HTML for explanation ")])])}]

export { render, staticRenderFns }